import React, { Component } from "react";

import { SiteWrap } from "luna-react/components/siteWrap";

import Header from "./components/common/Header";
import Content from "./components/common/Content";
import Footer from "./components/common/Footer";
import Page from "./components/common/Page";

import "./App.scss";
class App extends Component {
  render() {
    return (
      <SiteWrap>
        <div className="app__wrapper">
          <Header />
          <Page>
            <Content />
          </Page>
          <Footer />
        </div>
      </SiteWrap>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js